import beTwMerge from '@/utils/beTwMerge';

interface ITitleProps {
  alignment?: 'left' | 'center' | 'right' | 'unset';
  component?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'span';
  size?: 'extraLarge' | 'large' | 'medium' | 'small';
  children: React.ReactNode;
  className?: string;
  styles?: object;
  weight?: 'light' | 'normal' | 'medium' | 'bold' | 'black';
}

function Title({ alignment = 'center', size, weight, component = 'h2', children, className, styles }: ITitleProps) {
  const titleStyle =
    'tw-font-ebgaramond tw-normal-case tw-text-be-dark-gray tw-mt-0 tw-no-underline hover:tw-no-underline tw-mb-[24px] md:tw-mb-[32px]';
  const titleSizes = {
    extraLarge: 'tw-text-garamond-extralarge-mobile desktop:tw-text-garamond-extralarge-desktop',
    large: 'tw-text-garamond-large-mobile desktop:tw-text-garamond-large-desktop',
    medium: 'tw-text-garamond-medium-mobile desktop:tw-text-garamond-medium-desktop',
    small: 'tw-font-base tw-text-be-base desktop:tw-text-be-lg !tw-font-medium',
    extraSmall: 'tw-font-base tw-text-be-xs tablet:tw-text-be-sm desktop:tw-text-be-base',
  };
  const titleAligned = {
    left: 'tw-text-left',
    center: 'tw-text-center',
    right: 'tw-text-right',
    unset: '',
  };
  const titleWeight = {
    thin: 'tw-font-thin',
    extralight: 'tw-font-extralight',
    light: 'tw-font-light',
    normal: 'tw-font-normal',
    medium: 'tw-font-medium',
    semibold: 'tw-font-semibold',
    bold: 'tw-font-bold',
    extrabold: 'tw-font-extrabold',
    black: 'tw-font-black',
  };

  const defaultSize = {
    h1: titleSizes.extraLarge,
    h2: titleSizes.large,
    h3: titleSizes.medium,
    h4: titleSizes.small,
  };

  const Component = component;

  return (
    <Component
      className={beTwMerge(
        titleStyle,
        size ? titleSizes[size] : defaultSize[component],
        titleAligned[alignment],
        titleWeight[weight || 'normal'],
        className
      )}
      style={styles}
    >
      {children}
    </Component>
  );
}

export default Title;
